﻿import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {IconButton, MenuItem, SelectField} from 'material-ui';
import SearchIcon from 'material-ui/svg-icons/action/search';
import ListAppBar from '../core/list-app-bar';
import ChatArchiveList from './chat-archive-list'

class ChatArchive extends Component {

    constructor(props, context) {
        super(props, context);

        this.onSearchChange = this.onSearchChange.bind(this);

        this.chatList = [
            "bnnadminpvt@conference.bnn.adtsoft.com",
            "bnntac1@conference.bnn.adtsoft.com",
            "bnntac2@conference.bnn.adtsoft.com",
            "bnntac3@conference.bnn.adtsoft.com",
            "bnntac4@conference.bnn.adtsoft.com",
            "bnntac5@conference.bnn.adtsoft.com",
            "bnntac6@conference.bnn.adtsoft.com",
            "bnntac7@conference.bnn.adtsoft.com",
            "bnntac8@conference.bnn.adtsoft.com",
            "bnntac9@conference.bnn.adtsoft.com",
            "bnntac10@conference.bnn.adtsoft.com"
        ];
    }

    onSearchChange(event, value) {
        this.props.onSearch(this.chatList[value]);
        console.log(this.chatList[value]);
    }

    render() {

        const {selectedChat} = this.props;

        const selectedChatIndex = this.chatList.indexOf(selectedChat);

        const style = {
            color: "white"
        };

        return (
            <div>
                <ListAppBar title="Chat Archive"
                            iconElementRight={
                                <div style={{display: "inline-flex"}}>
                                    <IconButton iconStyle={style}><SearchIcon/></IconButton>
                                    <SelectField name="Chat" value={selectedChatIndex} onChange={this.onSearchChange}>
                                        <MenuItem value={0} primaryText="bnnadminpvt"/>
                                        <MenuItem value={1} primaryText="bnntac1"/>
                                        <MenuItem value={2} primaryText="bnntac2"/>
                                        <MenuItem value={3} primaryText="bnntac3"/>
                                        <MenuItem value={4} primaryText="bnntac4"/>
                                        <MenuItem value={5} primaryText="bnntac5"/>
                                        <MenuItem value={6} primaryText="bnntac6"/>
                                        <MenuItem value={7} primaryText="bnntac7"/>
                                        <MenuItem value={8} primaryText="bnntac8"/>
                                        <MenuItem value={9} primaryText="bnntac9"/>
                                        <MenuItem value={10} primaryText="bnntac10"/>
                                    </SelectField>
                                </div>
                            }
                />
                <ChatArchiveList/>
            </div>
        )
    }
}

ChatArchive.contextTypes = {
    router: PropTypes.any.isRequired
};

const mapStateToProps = state => ({...state.chatArchive});

const mapDispatchToProps = dispatch => ({
    onSearch: (selectedChat) =>
        dispatch({type: 'SEARCH_CHAT', payload: selectedChat})
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatArchive);